export const formatAsPrice = (
  price: number | string,
  locale = 'en-CA',
  showFractional = true
) => {
  // We need a country code so that CAD doesn't display on the formatted string
  const qualifiedLocal = locale === 'fr' ? 'fr-CA' : 'en-CA';
  const formatter = new Intl.NumberFormat(qualifiedLocal, {
    style: 'currency',
    currency: 'CAD',
    maximumFractionDigits: showFractional ? 2 : 0,
    minimumFractionDigits: showFractional ? 2 : 0,
  });
  return formatter.format(Number(price));
};
